import Grow from "@mui/material/Grow";
import Paper from "@mui/material/Paper";
import Skeleton from "@mui/material/Skeleton";
import { useTheme } from "@mui/material";

const Widget = props => {
  const { widgetLayout = "column" } = props;

  const theme = useTheme();

  return (
    <Grow in={true}>
      <Paper
        sx={{
          backgroundColor: theme.palette.commonground.main,
          color: theme.palette.commonground.contrastText,
          borderRadius: theme.shape.borderRadius,
          boxShadow: theme.shadows[3],
          position: "relative",
          display: "flex",
          flexDirection: widgetLayout,
          overflowY: "hidden",
          overflowX: "hidden",
          width: "100%",
          height: "100%",
        }}
      >
        <Skeleton
          sx={{ margin: 0, marginLeft: theme.spacing(2), marginRight: theme.spacing(2) }}
          variant="text"
          height="100%"
        ></Skeleton>
        <Skeleton
          sx={{ margin: 0, marginLeft: theme.spacing(2), marginRight: theme.spacing(2) }}
          variant="text"
          height="100%"
        ></Skeleton>
        <Skeleton
          sx={{ margin: 0, marginLeft: theme.spacing(2), marginRight: theme.spacing(2) }}
          variant="text"
          height="100%"
        ></Skeleton>
        <Skeleton
          sx={{ margin: 0, marginLeft: theme.spacing(2), marginRight: theme.spacing(2) }}
          variant="text"
          height="100%"
        ></Skeleton>
      </Paper>
    </Grow>
  );
};

export default Widget;
